/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import defaultUser from "assets/images/default-user.jpg";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

export default function dealersTableData({
  dealers = [],
  editAction,
  deletAction,
  onImageClick,
}) {
  const columns = [
    {
      Header: "id",
      accessor: "id",
      align: "left",
    },
    {
      Header: "dealer",
      accessor: "name",
      width: "45%",
      align: "left",
      Cell: ({ row, value }) => {
        const dealer = row.original;
        const image = dealer.image || defaultUser;

        return (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDAvatar
              src={image}
              name={value}
              size="sm"
              sx={{ cursor: "pointer" }}
              onClick={() => onImageClick?.(image)}
            />
            <MDBox ml={2} lineHeight={1}>
              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                sx={{ cursor: "pointer" }}
                onClick={() => editAction?.(dealer)}
              >
                {value}
              </MDTypography>
            </MDBox>
          </MDBox>
        );
      },
    },
    {
      Header: "email",
      accessor: "email",
      align: "left",
    },
    {
      Header: "studios",
      accessor: "studios",
      align: "center",
    },
    {
      Header: "games",
      accessor: "games",
      align: "center",
    },
    {
      Header: "action",
      id: "action",
      align: "center",
      disableSortBy: true,
      Cell: ({ row }) => {
        const dealer = row.original;

        return (
          <MDBox display="flex" justifyContent="center" alignItems="center">
            <IconButton
              aria-label="edit"
              onClick={() => editAction?.(dealer)}
              sx={{ color: "text.primary", paddingRight: 1 }}
            >
              <EditIcon fontSize="small" />
            </IconButton>

            <IconButton
              aria-label="delete"
              onClick={() => deletAction?.(dealer)}
              sx={{ color: "error.main" }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </MDBox>
        );
      },
    },
  ];

  const rows = dealers.map((dealer) => ({
    ...dealer,
    id: dealer.id,
    name: dealer.name || "",
    email: dealer.email || "",
    studios: dealer.studios?.map((studio) => studio.name).join(", ") || "",
    games: dealer.games?.map((game) => game.name).join(", ") || "",
    image: dealer.image || defaultUser,
  }));

  return {
    columns,
    rows,
  };
}